import { render } from "./Icon.vue?vue&type=template&id=3593dd61"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/WD 1/Development/Laravel/pessoalform_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__